// @ts-nocheck
// Starter Sync - VmiUsersHeader

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateSearchFields from "@insite/client-framework/Store/Pages/VmiUsers/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import AccordionSection from "@insite/mobius/AccordionSection";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import Tag, { TagPresentationProps } from "@insite/mobius/Tag";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import TagWrapper, { TagWrapperProps } from "@store/Library/Components/Toolkit/TagWrapper";
import { tableFilterProps } from "@store/Themes/common/props/table";
import * as React from "react";
import { useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    getVmiUsersParameter: state.pages.vmiUsers.getVmiUsersParameter,
});

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface VmiUsersFilterStyles {
    wrapper?: InjectableCss;
    accordion?: AccordionPresentationProps;
    tagWrapper?: TagWrapperProps;
    appliedFilterTag?: TagPresentationProps;
    filterContainer?: GridContainerProps;
    filterGridItem?: GridItemProps;
    roleFilterSelect?: SelectPresentationProps;
    clearFiltersButton?: ButtonPresentationProps;
}

export const vmiUsersFilterStyles: VmiUsersFilterStyles = {
    wrapper: tableFilterProps.wrapper,
    accordion: tableFilterProps.accordion,
    filterContainer: tableFilterProps.formGridContainer,
    filterGridItem: { width: [12, 7, 6, 5, 4] },
    clearFiltersButton: tableFilterProps.clearButton,
    tagWrapper: tableFilterProps.tagWrapper,
};

const styles = vmiUsersFilterStyles;

const VmiUsersFilter = ({ getVmiUsersParameter, updateSearchFields }: Props) => {
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const includeUserRole = getVmiUsersParameter.roles?.includes("VMI_User");
    const includeAdminRole = getVmiUsersParameter.roles?.includes("VMI_Admin");
    const selectRoleValue =
        includeUserRole && !includeAdminRole ? "User" : !includeUserRole && includeAdminRole ? "Admin" : "";

    const toggleFiltersOpen = () => {
        setIsFilterOpen(!isFilterOpen);
    };

    const handleChangeRoleFilter = (event: React.FormEvent<HTMLSelectElement>) => {
        let roles;
        if (event.currentTarget.value === "User") {
            roles = ["VMI_User"];
        } else if (event.currentTarget.value === "Admin") {
            roles = ["VMI_Admin"];
        } else {
            roles = ["VMI_User", "VMI_Admin"];
        }
        updateSearchFields({ roles });
    };

    const clearFiltersClickHandler = () => {
        updateSearchFields({ roles: ["VMI_User", "VMI_Admin"] });
    };

    const facets = selectRoleValue ? (
        <TagWrapper {...styles.tagWrapper}>
            <Tag {...styles.appliedFilterTag} onDelete={clearFiltersClickHandler}>
                {`${translate("{0}:", translate("Role"))} ${selectRoleValue}`}
            </Tag>
        </TagWrapper>
    ) : null;

    return (
        <StyledWrapper {...styles.wrapper}>
            <Accordion {...styles.accordion} headingLevel={2}>
                <AccordionSection
                    title={translate("Filters")}
                    expanded={isFilterOpen}
                    onTogglePanel={toggleFiltersOpen}
                >
                    <GridContainer {...styles.filterContainer}>
                        <GridItem {...styles.filterGridItem}>
                            <Select
                                label={translate("Role")}
                                {...styles.roleFilterSelect}
                                value={selectRoleValue}
                                onChange={handleChangeRoleFilter}
                            >
                                <option value="">{translate("Select")}</option>
                                <option key="User" value="User">
                                    {translate("User")}
                                </option>
                                <option key="Admin" value="Admin">
                                    {translate("Admin")}
                                </option>
                            </Select>
                        </GridItem>
                    </GridContainer>
                    <FormActions>
                        <Button {...styles.clearFiltersButton} onClick={clearFiltersClickHandler}>
                            {translate("Clear")}
                            <VisuallyHidden>{translate("All Filters")}</VisuallyHidden>
                        </Button>
                    </FormActions>
                </AccordionSection>
            </Accordion>
            {facets}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(VmiUsersFilter),
    definition: {
        group: "VMI Users",
        displayName: "Search Results Filters",
        allowedContexts: ["VmiUsersPage"],
    },
};

export default widgetModule;
